import { Row, Col } from "react-bootstrap";
import DepartureTimeBadge from "./DepartureTimeBadge.jsx";

/**
 * RealtimeStopRow - Display a single stop row with realtime updates,
 * topped up to three departures with scheduled times.
 */
export default function RealtimeStopRow({ stop, isCollapsed, isLastStop = false }) {
  const classes = [
    stop.timepoint ? "stop__row--timepoint" : "stop__row--non-timepoint",
    !isCollapsed && "stop__row--open",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <Row className={`stop__row ${classes}`} data-stop-id={stop.stop_id}>
      <Col xs={12} md={5} className="stop__row__info pl-3 mb-2">

        <div>
          {stop.stop_name} <span className="stop__row__id hidden">(Stop #{stop.stop_id})</span>
        </div>

      </Col>

      <Col xs={12} md={7} className="stop__row__arrivals">
        <div className="d-flex flex-wrap align-items-center justify-content-end gap-3 mb-2 w-100">
          {isLastStop ? (
            <p>Arrival Destination</p>
          ) : (
            <>
              {(stop.departures || []).map((update) => (
                <DepartureTimeBadge
                  key={`${update.trip_id}-${update.stop_id}-${update.stop_sequence}-${update.time_value}`}
                  update={update}
                  scheduledTime={update.scheduled ? update.time_value : undefined}
                />
              ))}
            </>
          )}
        </div>
      </Col>
    </Row>
  );
}
